import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'elementEditionOn'
})
export class ElementEditionOnPipe implements PipeTransform {
  transform(elementIndex: number, ongoingEditedElements: number[]): boolean {
    return ongoingEditedElements.includes(elementIndex);
  }
}